import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MetaGuard } from 'meta'
import { CollectionsResolver } from '../collections/collections.resolver'
import { EntityHubSmartComponent } from '../entity-hub/entity-hub-smart.component'
import { SegmentTagMap } from '../shared/analytics/models/segment-tag-map.model'
import { LEAGUES_LIST_TAG, LeaguesListComponent } from './leagues-list/leagues-list.component'
import { EmptyTab } from '../events/components/event-detail/event-tabs/empty-tab/empty-tab.component'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: LeaguesListComponent,
        data: {
          shouldShowEventTicker: true,
          segment: LEAGUES_LIST_TAG
        },
        canActivate: [MetaGuard]
      },
      {
        path: ':nodeId',
        component: EntityHubSmartComponent,
        canActivate: [MetaGuard],
        resolve: { collection: CollectionsResolver },
        children: [
          {
            path: '',
            component: EmptyTab,
            canActivate: [MetaGuard],
            data: {
              shouldShowAdSkin: false,
              noTopScroll: true,
              shouldShowEventTicker: true,
              segment: SegmentTagMap.COLLECTIONS_TAB_VIEW
            }
          },
          {
            path: ':tab',
            component: EmptyTab,
            canActivate: [MetaGuard],
            data: {
              shouldShowAdSkin: false,
              noTopScroll: true,
              shouldShowEventTicker: true,
              segment: SegmentTagMap.COLLECTIONS_TAB_VIEW
            }
          }
        ],
        data: {
          shouldShowEventTicker: true,
          segment: SegmentTagMap.COLLECTIONS_VIEW
        }
      }
    ])
  ],
  exports: [RouterModule]
})
export class LeaguesRoutingModule {}
